import { renderManagementCredentials } from './managementCredentials';

// title and field properties are used in material table,
// label and key are used in CSV export

export default user => {
  const columns = [
    { title: 'Username', field: 'username' },
    { title: 'Nome', field: 'name' },
    { title: 'E-mail', field: 'email' },
    {
      title: 'Credenciais de Gestão',
      field: 'administrator',
      editable: 'never',
      render: renderManagementCredentials,
    },
    { title: 'Conta cliente', field: 'name', editable: 'never' },
    { title: 'Ultimo Login', field: 'last_login', editable: 'never' }
  ];

  const columnsAdmin = [
    {
      title: 'Identificador',
      field: 'id',
      editable: 'never',
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
